var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusErrorOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7,7a.76.76,0,0,1-.75-.75V4a.75.75,0,0,1,1.5,0V6.25A.76.76,0,0,1,7,7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 9,
    r: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,14a1.76,1.76,0,0,1-1.26-.52L.52,8.26a1.79,1.79,0,0,1,0-2.52L5.74.52a1.79,1.79,0,0,1,2.52,0h0l5.22,5.22a1.79,1.79,0,0,1,0,2.52L8.26,13.48A1.76,1.76,0,0,1,7,14ZM7,1.5a.32.32,0,0,0-.2.08L1.58,6.8A.29.29,0,0,0,1.5,7a.3.3,0,0,0,.08.2L6.8,12.42a.28.28,0,0,0,.4,0L12.42,7.2A.3.3,0,0,0,12.5,7a.29.29,0,0,0-.08-.2L7.2,1.58A.32.32,0,0,0,7,1.5Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusErrorOutline);
export default __webpack_public_path__ + "static/media/status-error-outline.132b856362ec9500ab459df3e71d7c2e.svg";
export { ForwardRef as ReactComponent };